import _ from 'lodash'
// ASSET //
const asset = (schema) => {
  if (schema.type === 'string' && _.get(schema.options, 'assetType')) {
    return 'asset'
  }
}

// DATASET //
const dataset = (schema) => {
  if (schema.type === 'string' && _.get(schema.options, 'source') === 'datasets') {
    return 'dataset'
  }
}
// HotSpot //
const hotspot = (schema) => {
  if (schema.type === 'array' && _.get(schema.options, 'hotspot') === true) {
    return 'hotspot'
  }
}

// LARGE ARRAY //
const largeArray = (schema) => {
  if (schema.type === 'array' && _.get(schema.options, 'large') === true) {
    return 'largeArray'
  }
}

// Select Choices //
const selectChoices = (schema) => {
  if (schema.type === 'array' && schema.format === 'select' && _.get(schema.options, 'useMultiple') === true) {
    return 'selectChoices'
  }
}

// TAGS //
const tags = (schema) => {
  if (schema.type === 'array' && _.get(schema.options, 'tags') === true) {
    return 'tags'
  }
}

// EnumSourceHelper //
const enumSourceHelper = (schema) => {
  if (schema.type === 'enumSourceHelper') {
    return 'enumSourceHelper'
  }
}

// NestedArrayEnumSourceHelper //
const nestedArrayEnumSourceHelper = (schema) => {
  if (schema.type === 'nestedArrayEnumSourceHelper') {
    return 'nestedArrayEnumSourceHelper'
  }
}

// CSV Array Resolver //
const csvArray = (schema) => {
  if (schema.type === 'csvArray') {
    return 'csvArray'
  }
}

// Header Resolver //
const header = (schema) => {
  if (schema.type === 'header') {
    return 'header'
  }
}

// Type Selector //
const typeSelector = (schema) => {
  if (schema.type === 'type-selector') {
    return 'typeSelector'
  }
}

export default [asset, dataset, hotspot, largeArray, selectChoices, tags, enumSourceHelper, nestedArrayEnumSourceHelper, csvArray, header, typeSelector]